// withdraw
const Listwithdraw = () => import('@/views/withdraw')

export default {
    path: 'withdraw',
    redirect: '/withdraw',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'withdraw',
            component: Listwithdraw,
            meta: {
                link: 'withdraw',
                breadcrumb: [
                    { title: 'Withdraw', active: true },
                ],
                pageTitle: 'Withdraw'
            },
        }
    ]
}